import { render, staticRenderFns } from "./DownView.vue?vue&type=template&id=1cfc1b30&"
import script from "./DownView.vue?vue&type=script&lang=js&"
export * from "./DownView.vue?vue&type=script&lang=js&"
import style0 from "./DownView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DownView.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports